"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _glyph = _interopRequireDefault(require("../glyph"));

var _excluded = ["disabled"],
    _excluded2 = ["disabled"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ControlsWrapper = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "increment-controls__ControlsWrapper",
  componentId: "sc-14jx6tn-0"
})(["position:absolute;right:-8px;top:0;height:100%;width:21px;", ";"], (0, _styles.transitionEase)("0.3s", ["border"]));
var ControlButton = (0, _styledComponents["default"])(function (_ref) {
  var disabled = _ref.disabled,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Button, props);
}).withConfig({
  displayName: "increment-controls__ControlButton",
  componentId: "sc-14jx6tn-1"
})(["cursor:pointer;height:50%;width:100%;", "{", ";fill:", ";}", ";"], _glyph["default"], (0, _styles.transitionEase)("0.3s", ["fill"]), function (props) {
  return (0, _styles.colors)("icon-input", props);
}, function (_ref2) {
  var disabled = _ref2.disabled,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return !disabled ? (0, _styledComponents.css)(["&:hover{", "{fill:", ";}}"], _glyph["default"], (0, _styles.colors)("text", props)) : null;
});

var IncerementControls = function IncerementControls(_ref3) {
  var disabled = _ref3.disabled,
      handleDecrement = _ref3.handleDecrement,
      handleIncrement = _ref3.handleIncrement;
  return /*#__PURE__*/_react["default"].createElement(ControlsWrapper, {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(ControlButton, {
    disabled: disabled,
    onClick: handleIncrement
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    as: "span",
    height: 1,
    justifyContent: "center",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    as: "span",
    height: 10,
    width: 10
  }, /*#__PURE__*/_react["default"].createElement(_glyph["default"], {
    id: "triangle-up"
  })))), /*#__PURE__*/_react["default"].createElement(ControlButton, {
    disabled: disabled,
    onClick: handleDecrement
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    as: "span",
    height: 1,
    justifyContent: "center",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    as: "span",
    height: 10,
    width: 10
  }, /*#__PURE__*/_react["default"].createElement(_glyph["default"], {
    id: "triangle-down"
  })))));
};

IncerementControls.propTypes = {
  /** A boolean to represent whether the input field should be disabled */
  disabled: _propTypes.bool,

  /** A function to handle decrement */
  handleDecrement: _propTypes.func,

  /** A function to handle increment */
  handleIncrement: _propTypes.func
};
IncerementControls.displayName = "Modules.IncerementControls";
var _default = IncerementControls;
exports["default"] = _default;